/*
* Configures and calculates resized dimensions for a page preview to fit within a specified container,
* maintaining the original aspect ratio of the page. The function determines the maximum size the page
* can have, considering a fixed margin, and adjusts the page dimensions (width and height) based on its
* orientation (landscape or portrait).
* */
export const configurePreview = (state, containerRef, callback) => {
    // Checks if the callback is a function; otherwise, defaults to a no-op function
    const _callback = callback && typeof callback === "function" ? callback : () => {};
    if (!containerRef) {
        _callback();
    }

    // If no container is provided, invokes the callback immediately and exits the function
    const container = containerRef.getBoundingClientRect();
    const {pageSize} = state;

    // Defines the margin and calculates the maximum allowed size for the page
    const marginSize = 200;
    const maxPageSize = Math.min(container.width, container.height) - marginSize;

    // Checks the page orientation and calculates new dimensions to maintain aspect ratio
    const isLandscape = pageSize.width > pageSize.height;
    const [width, height] = isLandscape
        ? [maxPageSize, (pageSize.height / pageSize.width) * maxPageSize]
        : [(pageSize.width / pageSize.height) * maxPageSize, maxPageSize];

    // Calculates the scale factor for the new height relative to the original page height
    const scaleFactor = height / pageSize.height;

    // Calls the callback with the new page dimensions and the scale factor
    _callback({
        pageSize: {width, height},
        scaleFactor,
    });
};


// WEBPACK FOOTER //
// ./src/utils/configurePreview.js